import { createContext } from 'react'

const LayoutContext = createContext(null)

export default LayoutContext
